import Alpine from "alpinejs";
import { breakpointIs } from "../../breakpoint";
import { scrollToPos } from "../../chc/helpers";
import { ifMobile } from "../../chc/helpers";

const dataFN = (config) => {
    const opts = { open: false, openMore: false, showMax: null, display: "tabs", activeTab: [], activeAccordion: [], activeAccordions: [], ...config };

    return {
        ...opts,
        reloadHash: null,
        startPos: null,
        isDrag: false,
        init() {
            this.reloadHash = window.location.hash;
            this.scrollJump(this.reloadHash)
        },
        getTabIndex(tabId) {
            const _root = this.$root;
            const tab = _root.querySelector(`#${tabId}.tabComponent__tabList button`);
            if (tab) tab.click();
        },
        getMax(value) {
            this.showMax = value;
        },
        showItem: ({ showMax, openMore, index }) => showMax >= index || openMore,
        openTabURL() {
            let tabs = this.$root.querySelectorAll(".tabComponent__tabList");
            tabs.forEach((el, index) => {
                let id = "#" + el.id;
                let hash = window.location.hash;
                if (hash === id) {
                    let openTab = "tab-" + index;
                    this.setActiveTab(openTab);
                    scrollToPos(hash)
                }
            });
        },
        setLocationHash(tabId) {
            const newHash = tabId? `#${tabId}` : this.reloadHash;
            const currPage = window.location.pathname;

            const newurl =  `${currPage}${newHash}`;
            if (window.location.search.indexOf("tabId") == -1) {
                window.history.pushState(null, '', newurl);
            } else {
                window.history.replaceState(null, '', newurl);
            }

            this.reloadHash = "";
        },
        setActiveTab(id, isEditMode) {
            this.activeTab = id;
            const tabId = this.$el.parentNode.id;
            //maintain state between views            
            this.setActiveAccordion(id);
            this.toggleAccordion(id);

            if (!isEditMode) this.setLocationHash(tabId);

            const psWidget = this.$refs[id]?.querySelector(".ps-widget");
            if (psWidget && psWidget?.style?.display == "none") {
              window.PriceSpider?.rebind();
            }
        },
        setActiveAccordion(id) {
            if (!ifMobile()) return; 
            this.activeAccordion = id;
        },
        isAccordionActive(id) {
            return this.activeAccordions.includes(id);
        },
        isCurrTab(tab, isEditMode) {
            if (this.activeTab == tab) this.activeTab = "";
            else this.setActiveTab(tab, isEditMode);
        },
        toggleAccordion(id) {            
            if (!ifMobile()) return; 
            //toggle accordion active if closed
            if (this.activeAccordions.includes(id)) {
                this.activeAccordion = "";
                //keep state between mobile/desktop views
                //if accordion on mobile changes, also change tab view on desktop
                if (this.activeTab === id) {
                    this.activeTab = "";
                }
            }
            if (this.isAccordionActive(id)) {
                // Remove this is from array
                this.activeAccordions = this.activeAccordions.filter((item) => item != id);
                // if no tab in accordion is open, set the last active tab to desktop
                if (this.activeAccordions.length == 0) {
                    this.activeTab = id;
                }
            } else {
                // add id to array
                this.activeAccordions = [id];
                //also make active tab
                this.activeTab = id;
            }
        },
        removeClass(el, bClass = [], bool) {
            if (bool) bClass.forEach(val => el.classList.remove(val));
        },
        addClass(el, bClass = [], bool) {
            if (bool) bClass.forEach(val => el.classList.add(val));
        },
        addRemoveEvent(el, removeClass = [], addClass = [], bool) {
            this.removeClass(el, removeClass, bool);
            this.addClass(el, addClass, bool);
        },
        isOpen(id) {
            // Tabs mode
            if (this.display === "tabs") {
                return this.activeTab === id;
            }
            // MobileAccordion mode
            else {
                //if not mobile sized breakpoint
                if (breakpointIs("lg") || breakpointIs("xl")) {
                    return this.activeTab === id;
                } else {
                    return this.isAccordionActive(id);
                }
            }
        },
        // Pipe Tab
        hasNextTab: false,
        hasPrevTab: false,
        get tabSlideIconWidth() {
            const prevTabWidth = this.$refs.prevTab?.clientWidth || 0;
            const nextTabWidth = this.$refs.nextTab?.clientWidth || 0;
            return prevTabWidth + nextTabWidth;
        },
        goToNextTab() {
            const nextTabElement = this.getNextTabElement();
            this.scrollIntoView(nextTabElement);
        },
        goToPrevTab() {
            const previousElement = this.getPrevTabElement();
            this.scrollIntoView(previousElement);
        },
        scrollIntoView(element) {
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
            }
        },

        // getNextTabElement() {
        //     const clientWidth = this.$refs.tabs?.clientWidth;
        //     const scrollLeft = this.$refs.tabs?.scrollLeft;
        //     const totalClientWidth = clientWidth + scrollLeft;
        //     let totalTabWidth = 0;
        //     let nextTabElement = null;
        //     this.$refs.tabs.querySelectorAll("li").forEach(tab => {
        //         if (totalTabWidth >= totalClientWidth) {
        //             return;
        //         }
        //         const tabWidth = tab.clientWidth;
        //         totalTabWidth += tabWidth;

        //         nextTabElement = tab;
        //     });
        //     return nextTabElement;
        // },
        getNextTabElement() {
            const scrollLeft = this.$refs.tabs.scrollLeft + this.tabSlideIconWidth;
            let totalTabWidth = 0;
            let nextTabElement = null;
            let foundCurrent = false;
        
            this.$refs.tabs.querySelectorAll("li").forEach((tab) => {
                if (foundCurrent && !nextTabElement) {
                    nextTabElement = tab;
                }
                totalTabWidth += tab.clientWidth;
                if (totalTabWidth > scrollLeft && !foundCurrent) {
                    foundCurrent = true;
                }
            });
        
            return nextTabElement;
        },        
        getPrevTabElement() {
            const scrollLeft = this.$refs.tabs.scrollLeft - this.tabSlideIconWidth;
            let totalTabWidth = 0;
            let prevTabElement = null;
            this.$refs.tabs.querySelectorAll("li").forEach((tab, index) => {
                if (totalTabWidth <= scrollLeft || index == 0) {
                    prevTabElement = tab;
                }
                totalTabWidth += tab.clientWidth;
            });
            return prevTabElement;
        },
        displayTabSlider() {
            const offset = 10;
            const clientWidth = this.$refs.tabs?.clientWidth;
            const scrollWidth = this.$refs.tabs?.scrollWidth;
            const scrollLeft = this.$refs.tabs?.scrollLeft;
            const totalClientWidth = (clientWidth + scrollLeft) + offset;
            this.hasNextTab = scrollWidth > totalClientWidth;
            this.hasPrevTab = scrollLeft > 0;
        },
        dragElement(e) {
            if (!this.isDrag) return;
            const _self = this.$el;
            _self.scrollLeft = this.startPos?.left - (e.clientX - this.startPos?.x);
            _self.style.cursor = "grabbing";
            _self.querySelectorAll("button, [role='button']").forEach(el => el.style.cursor = "grabbing");
        },
        stopDrag() {
            this.isDrag = false;
            const _self = this.$el;
            _self.style.cursor = "auto";
            _self.querySelectorAll("button, [role='button']").forEach(el => el.style.cursor = "pointer");
        },
        mouseEvent(e) {
            const _self =  this.$el;
            if (!_self.classList.contains("scrollable")) return;

            this.startPos = {
                left: _self.scrollLeft,
                x: e.clientX
            };

            this.isDrag = true;
        },
        detectScroll(el) {
            const _self = el;
            const isScroll = _self.scrollWidth > _self.clientWidth;
            const indicatorRight = this.$refs?.scrollIndicatorRight;

            if (isScroll) {
                _self.classList.add("scrollable");
                indicatorRight.classList.remove("hidden");
            } else {
                _self.classList.remove("scrollable");
                indicatorRight.classList.add("hidden");
                indicatorRight.classList.add("hidden");
            }
        },
        resize(el) {
            window.addEventListener("resize", () => this.detectScroll(el));
        },
        scrollEvent() {
            const scrollLeft = this.$el?.scrollLeft;
            const showLeft = scrollLeft > 0 ? "remove" : "add";

            this.$refs?.scrollIndicatorLeft.classList[showLeft]("hidden");

            const newScrollLeft =  this.$el?.scrollLeft;
            const width= this.$el?.clientWidth;
            const scrollWidth= this.$el?.scrollWidth;
            const endScroll = scrollWidth - newScrollLeft - width;
            const showRight = endScroll > 0 ? "remove" : "add";

            this.$refs?.scrollIndicatorRight.classList[showRight]("hidden");
        },
        getExactPosition(el, container) {
            if (!el) return;

            const { x: xPos } = el?.getBoundingClientRect();
            const { x: containerPos } = container?.getBoundingClientRect();
            const elScrollPos = Math.round(xPos - containerPos);

            return elScrollPos;
        },
        scrollJump(hash) {
            if (!this.$root.querySelector(".tabPipeScroll")) return;
            
            const tabContainer = this.$refs?.tabContainer;

            if (!hash) {
                tabContainer.classList.remove("scroll-mandatory");
                return;
            }

            const jumpId = tabContainer.querySelector(hash);

            tabContainer.scrollTo({
                left: this.getExactPosition(jumpId, tabContainer),
                behavior: "smooth",
            });

            tabContainer.onscrollend = () => {
                tabContainer.classList.remove("scroll-mandatory");
            };
        },
        autoAdjustScroll() {
            let scrollBy = 0;
            const _self = this.$el;
            const tabContainer = this.$refs?.tabContainer;
            
            if (!tabContainer) return;

            this.$nextTick(() => {
                const containerWidth = tabContainer.clientWidth;
                const elWidth = _self.clientWidth;
                const exactPosition = this.getExactPosition(_self, tabContainer);
                const elExactView = exactPosition + elWidth;

                if (elExactView > containerWidth) scrollBy = elExactView - containerWidth;
                if (exactPosition < 0) scrollBy = exactPosition;
            
                if (scrollBy === 0) return;

                tabContainer.scrollBy({
                    left: scrollBy,
                    behavior: "smooth",
                });
            });
        }
    }
};

Alpine.data("tabs", dataFN);
window.sui = window.sui || {};
window.sui.tabs = dataFN;
